module.exports = __webpack_public_path__ + "img/b16.61562179.jpg";